import { render, staticRenderFns } from "./OpenAmountsTable.vue?vue&type=template&id=2735762a&"
import script from "./OpenAmountsTable.vue?vue&type=script&lang=js&"
export * from "./OpenAmountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports